import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Search } from 'lucide-react';
import { LeadRow } from './LeadRow';

export const LeadsTab = ({
  leads,
  filteredLeads,
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  onRefresh,
  expandedLeadId,
  leadActions,
  onToggleExpand,
  onUpdateStatus,
  onDeleteLead,
  onEditLead,
  onAddAction,
  onDeleteAction,
  onCommissionChange,
  onCommissionBlur,
  getActionIcon,
  formatDate,
  formatActionDate,
  formatCurrency,
}) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle>Leads Beheer</CardTitle>
          <Button onClick={onRefresh} variant="outline" size="sm" data-testid="refresh-leads-button">
            Vernieuwen
          </Button>
        </div>

        {/* Filters */}
        <div className="flex gap-4 mt-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
              <Input
                placeholder="Zoek op naam, email of telefoon..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10"
                data-testid="search-input"
              />
            </div>
          </div>
          <div className="w-48">
            <Select value={statusFilter} onValueChange={setStatusFilter}>
              <SelectTrigger data-testid="status-filter">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Alle statussen</SelectItem>
                <SelectItem value="nieuw">Nieuw</SelectItem>
                <SelectItem value="in_behandeling">In behandeling</SelectItem>
                <SelectItem value="afspraak">Afspraak</SelectItem>
                <SelectItem value="klant_geworden">Klant geworden</SelectItem>
                <SelectItem value="geen_klant_geworden">Geen klant</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-8"></TableHead>
                <TableHead>Datum</TableHead>
                <TableHead>Countdown</TableHead>
                <TableHead>Naam & Adres</TableHead>
                <TableHead>Contact</TableHead>
                <TableHead>Providers</TableHead>
                <TableHead>Diensten</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Toegewezen</TableHead>
                <TableHead>Laatste Actie</TableHead>
                <TableHead className="text-center w-12">€</TableHead>
                <TableHead>Energie</TableHead>
                <TableHead>Acties</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filteredLeads.map((lead) => (
                <LeadRow
                  key={lead.id}
                  lead={lead}
                  isExpanded={expandedLeadId === lead.id}
                  leadActions={leadActions[lead.id]}
                  onToggleExpand={onToggleExpand}
                  onUpdateStatus={onUpdateStatus}
                  onDeleteLead={onDeleteLead}
                  onEditLead={onEditLead}
                  onAddAction={onAddAction}
                  onDeleteAction={onDeleteAction}
                  onCommissionChange={onCommissionChange}
                  onCommissionBlur={onCommissionBlur}
                  getActionIcon={getActionIcon}
                  formatDate={formatDate}
                  formatActionDate={formatActionDate}
                  formatCurrency={formatCurrency}
                />
              ))}
            </TableBody>
          </Table>

          {filteredLeads.length === 0 && (
            <div className="text-center py-8 text-slate-500">
              {searchTerm || statusFilter !== 'all'
                ? 'Geen leads gevonden met deze filters.'
                : 'Nog geen leads ontvangen.'}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
